import { bindAjaxCartForms } from "~/core/cart-drawer/bind-ajax-cart-forms";
import { makeEventNamespace } from "~/core/dom/events";
import { initSection } from "~/core/shopify/init-section";
import "~/styles/sections/system-finder.css";

initSection(".js-systems-comparison-section", (section) => {
    const namespace = makeEventNamespace();
    bindAjaxCartForms(namespace, section);
    const scroller = section.querySelector<HTMLElement>(
        "[data-system-comparison-scroller]",
    );
    const headers = Array.from(
        section.querySelectorAll<HTMLElement>(
            "[data-system-comparison-header]",
        ),
    );
    const mobile = window.matchMedia("(max-width: 1023px)");
    let frame: number | null = null;

    const setColumn = (index: number): void => {
        section
            .querySelectorAll<HTMLElement>("[data-system-comparison-column]")
            .forEach((cell) => {
                cell.classList.toggle(
                    "is-active",
                    cell.dataset.systemComparisonColumn === String(index),
                );
            });
    };

    const updateColumn = (): void => {
        if (scroller === null || headers.length < 2) return;
        const target = scroller.scrollLeft + scroller.clientWidth * 0.72;
        let activeIndex = 0;
        let activeDistance = Number.POSITIVE_INFINITY;

        headers.forEach((header, index) => {
            const distance = Math.abs(
                header.offsetLeft + header.offsetWidth / 2 - target,
            );
            if (distance < activeDistance) {
                activeIndex = index;
                activeDistance = distance;
            }
        });
        setColumn(activeIndex);
    };

    if (scroller !== null && headers.length > 1) {
        namespace.addDirectEventListener(
            scroller,
            "scroll",
            () => {
                if (!mobile.matches || frame !== null) return;
                frame = window.requestAnimationFrame(() => {
                    updateColumn();
                    frame = null;
                });
            },
            { passive: true },
        );
    }

    return {
        unload: () => {
            if (frame !== null) window.cancelAnimationFrame(frame);
            namespace.destroy();
        },
    };
});
